import { render } from "./ApiLimitField.vue?vue&type=template&id=5bfd2622&scoped=true"
import script from "./ApiLimitField.vue?vue&type=script&lang=js"
export * from "./ApiLimitField.vue?vue&type=script&lang=js"

import "./ApiLimitField.vue?vue&type=style&index=0&id=5bfd2622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfd2622"]])

export default __exports__